var Scinet = Scinet || {};
Scinet.selectric = Scinet.selectric || {};

Scinet.selectric.init = function (elem) {
    if (elem) {
        $(elem).find("select").scinetSelectric();
    } else {
        $("select").scinetSelectric();
    }
}

$(function () {
    // mobile menu button
    $(".navbar-toggle").on(
        "click",
        function () {
            $(this).toggleClass("active");
        });

    // custom inputs animation
    Scinet.toggleFilledClass = function (input) {
        var $input = $(input);

        if ($input.val() === null) {
            return;
        }

        if ($input.is("select")) {
            var wrapper = $input.parents(".input-label-block").children(".selectric-label");

            if (wrapper) {
                wrapper.toggleClass("filled", $input.val().length > 0);
            }
        } else if ($input.hasClass("ui-spinner-input")) {
            $input.parent().toggleClass("filled", $input.val().length > 0);
        } else {
            $input.toggleClass("filled", $input.val().length > 0);
        }
    };

    var toggleFilledClass = function () {
        Scinet.toggleFilledClass(this);
    };

    var toggleFilledClassForInputNumber = function (event) {
        var $input = $(this);
        if (event.target.validity.badInput) {
            $input.parent().toggleClass("filled", true);
        } else if ($input.val() === null || $input.val().length === 0) {
            $input.parent().toggleClass("filled", false);
        }
    };

    var removeValMsgOnSelectChanged = function () {
        var $input = $(this),
            val = $input.val();

        if (val && val.length) {
            var id = $input.attr("id");

            $("span.field-validation-error[data-valmsg-for='" + id + "']").remove();
        }
    }

    $(".input-label-block input, .input-label-block textarea, .input-label-block select").each(toggleFilledClass);
    $("body").on("change", ".input-label-block input, .input-label-block textarea, .input-label-block select", toggleFilledClass);
    $("body").on("blur", ".input-label-block input[type=number]", toggleFilledClassForInputNumber);
    $("body").on("change", "select", removeValMsgOnSelectChanged);

    $("body").on("click", ".button-plus, .button-minus",
        function (e) {
            var target;
            // The currentTarget property always refers to the element whose event listener triggered the event, opposed to the target property, which returns the element that triggered the event. (in our case it's could be <SVG> element not a <a>)
            if (!e.currentTarget) {
                target = e.target;
            } else {
                target = e.currentTarget;
            }

            if (!$(target).is(".button-plus, .button-minus")) {
                return;
            }

            var nameSelector = $(this).attr("data-val"),
                countField = $("input[name = \"" + nameSelector + "\"]"),
                countFieldValue = parseInt(countField.val()),
                isPlusButton = $(target).is(".button-plus");

            if (isPlusButton && $.isNumeric(countFieldValue)) {
                countField.val(++countFieldValue);
            }

            if (!isPlusButton && countFieldValue > 0) {
                countField.val(--countFieldValue);
            }
        });

    window.autosize($("textarea"));

    Scinet.selectric.init();

    $("body").on("click", "a[data-ajax=true]", function (e) {
        e.preventDefault();
    });

    $(window).on("beforeunload", function () {
        Scinet.busy.unlock();
    });

    $(function () {
        var clipboard = new ClipboardJS(".icon-copy");

        clipboard.on("success", function (e) {
            var $icon = $(e.trigger);
            var originalName = "data-original-title";
            var prevTitle = $icon.attr(originalName);

            $icon.addClass("icon-copied").removeClass("icon-copy");
            $icon.attr(originalName, "Copied!")
                .tooltip("show");

            setTimeout(function () {
                $icon.attr(originalName, prevTitle).tooltip("hide");
                $icon.addClass("icon-copy").removeClass("icon-copied");
            }, 3000);

            e.clearSelection();
        });
    });
});
